// @ts-nocheck
/**
 * ドラフトシステム - デッキ検証
 */

import { DRAFT_CONFIG } from '../constants';

// ========================================
// デッキ検証
// ========================================

/**
 * デッキが有効かチェック
 * @param {Object[]} deck - デッキ内のカード
 * @returns {Object} { isValid, errors, warnings }
 */
export const validateDeck = (deck) => {
  const errors = [];
  const warnings = [];

  // サイズチェック
  if (deck.length < DRAFT_CONFIG.MIN_DECK_SIZE) {
    errors.push(`デッキが${DRAFT_CONFIG.MIN_DECK_SIZE}枚未満です（現在${deck.length}枚）`);
  }

  if (deck.length > DRAFT_CONFIG.MAX_DECK_SIZE) {
    errors.push(`デッキが${DRAFT_CONFIG.MAX_DECK_SIZE}枚を超えています（現在${deck.length}枚）`);
  }

  // モンスターカードの最低枚数チェック
  const monsters = deck.filter(c => c.type === 'monster');
  if (monsters.length < 15) {
    warnings.push(`モンスターカードが少なめです（${monsters.length}枚）`);
  }

  // コスト曲線チェック
  const lowCost = deck.filter(c => (c.cost || 0) <= 2).length;
  const highCost = deck.filter(c => (c.cost || 0) >= 5).length;

  if (lowCost < 5) {
    warnings.push(`低コスト（1-2）カードが少なめです（${lowCost}枚）`);
  }

  if (highCost > 10) {
    warnings.push(`高コスト（5+）カードが多めです（${highCost}枚）`);
  }

  return {
    isValid: errors.length === 0,
    errors,
    warnings,
  };
};

/**
 * デッキ統計を計算
 * @param {Object[]} deck - デッキ内のカード
 * @returns {Object} 統計情報
 */
export const calculateDeckStats = (deck) => {
  const stats = {
    total: deck.length,
    byType: {
      monster: 0,
      magic: 0,
      field: 0,
      phase: 0,
    },
    byCost: {
      low: 0,      // 1-2
      mid: 0,      // 3-4
      high: 0,     // 5+
    },
    byAttribute: {},
    averageCost: 0,
  };

  let totalCost = 0;

  deck.forEach(card => {
    // タイプ別
    if (stats.byType[card.type] !== undefined) {
      stats.byType[card.type]++;
    }

    // コスト別
    const cost = card.cost || 0;
    totalCost += cost;

    if (cost <= 2) stats.byCost.low++;
    else if (cost <= 4) stats.byCost.mid++;
    else stats.byCost.high++;

    // 属性別
    const attr = card.attribute || 'なし';
    stats.byAttribute[attr] = (stats.byAttribute[attr] || 0) + 1;
  });

  stats.averageCost = deck.length > 0
    ? (totalCost / deck.length).toFixed(1)
    : 0;

  return stats;
};

/**
 * コスト曲線データを生成（グラフ表示用）
 * @param {Object[]} deck - デッキ内のカード
 * @returns {Object[]} コスト曲線データ
 */
export const generateCostCurve = (deck) => {
  const curve = {};

  deck.forEach(card => {
    const cost = card.cost || 0;
    curve[cost] = (curve[cost] || 0) + 1;
  });

  // 0-7+のデータを生成
  const result = [];
  for (let i = 0; i <= 7; i++) {
    const label = i === 7 ? '7+' : String(i);
    const count = i === 7
      ? Object.entries(curve)
        .filter(([k]) => parseInt(k) >= 7)
        .reduce((sum, [, v]) => sum + v, 0)
      : curve[i] || 0;

    result.push({ cost: label, count });
  }

  return result;
};

export default {
  validateDeck,
  calculateDeckStats,
  generateCostCurve,
};
